/** Ruta única de system_menu (sin slash). */
export const MENU_CHEQUES_FISICOS = "cheques_fisicos";

export const SUC_CASA_CENTRAL = 8;
export const SUC_AZUL = 20;

export const VISTA_CC = {
  CARTERA: "cartera",
  TRANSITO: "transito",
};

export const TIPO_DEPOSITO = {
  BANCO: "banco",
  RECAUDADORA: "recaudadora",
};

export const VIGENCIA_CHEQUE_DIAS = 30;
export const ALERTA_VENCIMIENTO_CHEQUE_DIAS = 7;

export const ALERTA_VENCIMIENTO_CHEQUE = {
  PROXIMO: "proximo",
  VENCIDO: "vencido",
};

export const ESTADOS_FISICOS = {
  DISPONIBLE: "Disponible",
  DEPOSITADO: "Depositado",
  ENDOSADO: "Endosado",
  RECHAZADO: "Rechazado",
  EMITIDO: "Emitido",
};

export const CUSTODIA = {
  EN_SUCURSAL: "en_sucursal",
  EN_TRANSITO_CC: "en_transito_cc",
  EN_CASA_CENTRAL: "en_casa_central",
  DEPOSITADO_BANCO: "depositado_banco",
  ENTREGADO_RECAUDADORA: "entregado_recaudadora",
};

export const LABEL_ESTADO_FISICO = {
  Disponible: "Disponible",
  Depositado: "Depositado",
  Endosado: "Endosado",
  Rechazado: "Rechazado",
  Emitido: "Emitido",
};

export const LABEL_CUSTODIA = {
  en_sucursal: "En sucursal",
  en_transito_cc: "En tránsito a Casa Central",
  en_casa_central: "En Casa Central",
  depositado_banco: "Depositado en banco",
  entregado_recaudadora: "En recaudadora",
};

const claveLabel = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const labelDesdeMapa = (mapa, value) => {
  const k = claveLabel(value);
  if (!k) return null;
  if (mapa[k]) return mapa[k];
  const hit = Object.entries(mapa).find(([key]) => key.toLowerCase() === k);
  return hit ? hit[1] : null;
};

const labelSinGuiones = (value) =>
  String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const ESTADOS_FILTRO_FISICOS = [
  { value: "", label: "Todos" },
  { value: "Disponible", label: "Disponible" },
  { value: "Emitido", label: "Emitido" },
  { value: "Depositado", label: "Depositado" },
  { value: "Endosado", label: "Endosado" },
  { value: "Rechazado", label: "Rechazado" },
];

export const CUSTODIA_FILTRO = [
  { value: "", label: "Todas" },
  { value: CUSTODIA.EN_SUCURSAL, label: LABEL_CUSTODIA.en_sucursal },
  { value: CUSTODIA.EN_TRANSITO_CC, label: LABEL_CUSTODIA.en_transito_cc },
  { value: CUSTODIA.EN_CASA_CENTRAL, label: LABEL_CUSTODIA.en_casa_central },
  { value: CUSTODIA.DEPOSITADO_BANCO, label: LABEL_CUSTODIA.depositado_banco },
  {
    value: CUSTODIA.ENTREGADO_RECAUDADORA,
    label: LABEL_CUSTODIA.entregado_recaudadora,
  },
];

export const ALERTA_VENCIMIENTO_FILTRO = [
  { value: "", label: "Todas" },
  {
    value: ALERTA_VENCIMIENTO_CHEQUE.PROXIMO,
    label: "Próximo a vencer (7 días)",
  },
  {
    value: ALERTA_VENCIMIENTO_CHEQUE.VENCIDO,
    label: "Vencido (≥30 días)",
  },
];

const CUSTODIAS_ALERTA_ACTIVAS = new Set([
  CUSTODIA.EN_SUCURSAL,
  CUSTODIA.EN_TRANSITO_CC,
  CUSTODIA.EN_CASA_CENTRAL,
]);

/** Normaliza badges del GET /cheques-fisicos/resumen. */
export const badgesDesdeResumenFisicos = (data) => {
  const b = data?.badges || {};
  return {
    alerta_vencimiento_proximo: Number(b.alerta_vencimiento_proximo ?? 0),
    alerta_vencimiento_vencido: Number(b.alerta_vencimiento_vencido ?? 0),
  };
};

export const colorAlertaVencimiento = (alerta) => {
  const a = String(alerta || "").toLowerCase();
  if (a === ALERTA_VENCIMIENTO_CHEQUE.VENCIDO) return "error";
  if (a === ALERTA_VENCIMIENTO_CHEQUE.PROXIMO) return "warning";
  return "default";
};

export const labelAlertaVencimiento = (alerta) => {
  const a = String(alerta || "").toLowerCase();
  if (a === ALERTA_VENCIMIENTO_CHEQUE.VENCIDO) return "Vencido";
  if (a === ALERTA_VENCIMIENTO_CHEQUE.PROXIMO) return "Próximo a vencer";
  return null;
};

/** Deriva alerta_vencimiento si el backend no la envió (fallback). */
export const derivarAlertaVencimiento = (cheque) => {
  const raw = cheque?.alerta_vencimiento;
  if (raw != null && raw !== "") {
    const a = String(raw).toLowerCase();
    if (a === ALERTA_VENCIMIENTO_CHEQUE.PROXIMO) {
      return ALERTA_VENCIMIENTO_CHEQUE.PROXIMO;
    }
    if (a === ALERTA_VENCIMIENTO_CHEQUE.VENCIDO) {
      return ALERTA_VENCIMIENTO_CHEQUE.VENCIDO;
    }
    return null;
  }

  if (cheque?.estado !== ESTADOS_FISICOS.DISPONIBLE) return null;
  const custodia = claveLabel(cheque?.estado_custodia || cheque?.custodia);
  if (!CUSTODIAS_ALERTA_ACTIVAS.has(custodia)) return null;

  const dias = Number(cheque?.dias_desde_emision);
  if (!Number.isFinite(dias)) return null;
  if (dias >= VIGENCIA_CHEQUE_DIAS) return ALERTA_VENCIMIENTO_CHEQUE.VENCIDO;
  if (dias >= VIGENCIA_CHEQUE_DIAS - ALERTA_VENCIMIENTO_CHEQUE_DIAS) {
    return ALERTA_VENCIMIENTO_CHEQUE.PROXIMO;
  }
  return null;
};

export const filaSxAlertaVencimiento = (alerta, zebraPar) => {
  const a = String(alerta || "").toLowerCase();
  if (a === ALERTA_VENCIMIENTO_CHEQUE.VENCIDO) {
    return { backgroundColor: "#ffebee !important" };
  }
  if (a === ALERTA_VENCIMIENTO_CHEQUE.PROXIMO) {
    return { backgroundColor: "#fff8e1 !important" };
  }
  return { backgroundColor: zebraPar ? "#fff" : "#f7f7f7" };
};

export const labelEstadoFisico = (estado) =>
  labelDesdeMapa(LABEL_ESTADO_FISICO, estado) ||
  labelDesdeMapa(LABEL_CUSTODIA, estado) ||
  (estado ? labelSinGuiones(estado) : "—");

export const labelCustodia = (custodia) =>
  labelDesdeMapa(LABEL_CUSTODIA, custodia) ||
  (custodia ? labelSinGuiones(custodia) : "—");

export const colorEstadoFisico = (estado) => {
  const e = claveLabel(estado);
  if (LABEL_CUSTODIA[e] || e.startsWith("en_") || e.includes("deposit")) {
    return colorCustodia(e);
  }
  if (e === "disponible") return "success";
  if (e === "emitido") return "info";
  if (e.includes("endos")) return "primary";
  if (e.includes("rechaz")) return "error";
  return "default";
};

export const labelAccionFisico = (accion) => {
  if (!accion) return "";
  const mapped = labelDesdeMapa(
    {
      enviar_cc: "Enviar a Casa Central",
      recibir_cc: "Recibir en Casa Central",
      depositar: "Depositar",
      faltante: "Faltante",
      corregir: "Corregir",
      rechazo: "Rechazo",
    },
    accion
  );
  if (mapped) return mapped;
  return labelSinGuiones(accion)
    .replace(/\bCc\b/g, "Casa Central")
    .replace(/\bCC\b/g, "Casa Central");
};

export const colorCustodia = (custodia) => {
  const c = claveLabel(custodia);
  if (c === CUSTODIA.EN_SUCURSAL) return "success";
  if (c === CUSTODIA.EN_TRANSITO_CC) return "warning";
  if (c === CUSTODIA.EN_CASA_CENTRAL) return "info";
  if (c === CUSTODIA.DEPOSITADO_BANCO) return "primary";
  if (c === CUSTODIA.ENTREGADO_RECAUDADORA) return "primary";
  return "default";
};

export const normalizarRutaMenu = (ruta) =>
  String(ruta || "")
    .trim()
    .replace(/^\/+/, "")
    .toLowerCase();

export const esCasaCentral = (idSucursal) =>
  Number(idSucursal) === SUC_CASA_CENTRAL;

export const idSucursalDe = (row) => {
  const n = Number(row?.id ?? row?.id_sucursal ?? row?.sucursal);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const nombreSucursalDe = (row) =>
  row?.nombre ||
  row?.nombre_sucursal ||
  row?.sucursal_nombre ||
  row?.sucursal ||
  (idSucursalDe(row) != null ? `Sucursal ${idSucursalDe(row)}` : "—");

export const sucursalesAutorizadas = () =>
  String(localStorage.getItem("suc_auth") || "")
    .split(",")
    .map((s) => Number(String(s).trim()))
    .filter((n) => Number.isFinite(n) && n > 0);

const normalizarTiposDeposito = (tipos, tieneRecaudadora) => {
  if (Array.isArray(tipos) && tipos.length) {
    return tipos.map((t) => String(t).toLowerCase());
  }
  if (tieneRecaudadora) return [TIPO_DEPOSITO.BANCO, TIPO_DEPOSITO.RECAUDADORA];
  return [TIPO_DEPOSITO.BANCO];
};

/** Tipos de depósito permitidos (cheque.acciones > sucursal > default banco). */
export const tiposDepositoPermitidos = (cheque, sucursal) => {
  const fromCheque = cheque?.acciones?.tipos_deposito_permitidos;
  if (Array.isArray(fromCheque) && fromCheque.length) {
    return fromCheque.map((t) => String(t).toLowerCase());
  }
  const tieneRecaudadora = Boolean(
    sucursal?.tiene_recaudadora ??
      sucursal?.cheques_tiene_recaudadora ??
      cheque?.acciones?.puede_depositar_recaudadora
  );
  return normalizarTiposDeposito(
    sucursal?.tipos_deposito_permitidos,
    tieneRecaudadora
  );
};

export const puedeDepositarRecaudadora = (cheque, sucursal) => {
  if (cheque?.acciones?.puede_depositar_recaudadora === false) return false;
  if (cheque?.acciones?.puede_depositar_recaudadora === true) return true;
  return tiposDepositoPermitidos(cheque, sucursal).includes(
    TIPO_DEPOSITO.RECAUDADORA
  );
};

/** Azul (20) y Casa Central (8) pueden pagar proveedores con cheque físico. */
export const sucursalOpFisicos = () => {
  const ids = sucursalesAutorizadas();
  if (ids.includes(SUC_CASA_CENTRAL)) return SUC_CASA_CENTRAL;
  if (ids.includes(SUC_AZUL)) return SUC_AZUL;
  return null;
};

/** Resuelve sucursal OP usando flags del GET /sucursales. */
export const sucursalOpFisicosDesdeLista = (sucursales = []) => {
  const auth = sucursalesAutorizadas();
  const habilitadas = (Array.isArray(sucursales) ? sucursales : []).filter(
    (s) => {
      const id = idSucursalDe(s);
      if (!id || !auth.includes(id)) return false;
      if (s.puede_pagar_con_fisicos === true) return true;
      return id === SUC_CASA_CENTRAL || id === SUC_AZUL;
    }
  );
  if (habilitadas.some((s) => idSucursalDe(s) === SUC_CASA_CENTRAL)) {
    return SUC_CASA_CENTRAL;
  }
  if (habilitadas.some((s) => idSucursalDe(s) === SUC_AZUL)) {
    return SUC_AZUL;
  }
  const first = habilitadas[0];
  return first ? idSucursalDe(first) : sucursalOpFisicos();
};

export {
  ORIGEN_CHEQUE,
  LABEL_ORIGEN_CHEQUE,
  ABREV_ORIGEN_CHEQUE,
  ORIGEN_CHEQUE_FILTRO,
  origenChequeDe,
  labelOrigenCheque,
  abrevOrigenCheque,
  colorOrigenCheque,
  camposOrigenCheque,
  esChequePropio,
  queryOrigenCheque,
  idFilaCheque,
} from "../cheques_proveedores/cheques.constants";

/** id de cac_recibo_instrumento_bancario (tipo 3). No es cheques_recibidos.id. */
export const idInstrumentoFisico = (cheque) => {
  const n = Number(
    cheque?.id_instrumento_bancario ?? cheque?.id ?? cheque?.id_instrumento
  );
  return Number.isFinite(n) && n > 0 ? n : null;
};
